export const LANG_TA_NAME = 'ta';

export const LANG_TA_TRANS = {
    'Family':'குடும்ப',
    'User Name': 'பயனர் பெயர்',
    'Username': 'பயனர் பெயர்',
    'User': 'பயனர் ',
    'Add Phone Number':' தொலைபேசி எண் சேர்க்கவும்',
    'Phone Number':'தொலைபேசி எண்',
    'All Users': 'அனைத்து பயனாளர்கள்',
    'Password': 'கடவுச்சொல்',
    'LOG IN': 'உள் நுழை',
    'Role': 'பங்கு',
    'Vazipadu': 'பூஜை',
    'Vazhipadu': 'பூஜை',
    'Pooja': 'பூஜை',
    'Deity': 'தேவி',
    'Avakasi':'பூஜா வாரிசு',
    'Vihitham':'பகிர்',
    'Category': 'வகை',
    'Code': 'குறியீடு',
    'Description': 'விளக்கம்',
    'Properties': 'உடைமை',
    'Name': 'பெயர்',
    'HOME': 'முகப்பு',
    'Update Stock': 'பங்கு புதுப்பிக்கவும்',
    'Administration': 'நிர்வாகம்',
    'Account': 'கணக்கு',
    'Head': 'தலைமை',
    'Qty': 'அளவு ',
    'Edit':'தொகு',
    'Auditorium Enquiry Edit': 'ஆடிட்டோரியம் விசாரணை',
    'Auditorium Enquiry View': 'ஆடிட்டோரியம் விசாரணை பார்வை',
    'Personal Id Pooja Report': 'தனிப்பட்ட ஐடியா பூஜா அறிக்கை',
    'Registered Devotee Pooja Report': 'பதிவு செய்யப்பட்ட பக்தர் பூஜை அறிக்கை',
    'Add Personal Devotee': 'தனிப்பட்ட பக்தியை சேர்க்கவும்',
    'Add Devotee': 'பக்தியை சேர்க்கவும்',
    'Personal': 'தனிநபர்',
    'Account Head': 'கணக்கு தலைமை',
    'Access Rights': 'அணுகல் உரிமைகள்',
    'Cheque Enquiry': 'Cheque விசாரணை',
    'Add User': 'பயனர் சேர்',
    'Account Balance': 'கணக்கு இருப்பு',
    'Vazhipadu Head': 'பூஜா தலை',
    'Vendor / Customer': 'விற்பனையாளர் / வாடிக்கையாளர்',
    'Vendor': 'விற்பனையாளர்',
    'Auto Back Up':'தானியங்கு காப்புப் பிரதி',
    'Customer': 'வாடிக்கையாளர்',
    'Avakasi Vihitham':'பூஜா ஷாரே',
    'Employees': 'ஊழியர்',
    'Employee': 'ஊழியர்',
    'Product': 'விளைபொருள்',
    'Per Pooja Items Report':'பூஜை பொருட்கள் அறிக்கை ஒன்றுக்கு',
    'Products': 'விளைபொருள்',
    'Vazhipad': ' பூஜா',
    'Expense': 'செலவு',
    'Detailed': 'விவரமான',
    'No data available': 'தரவு எதுவும் கிடைக்கவில்லை',
    'Statement': 'அறிக்கை',
    'Bank': 'வங்கி',
    'Add': 'கூட்டு',
    'Nadavaravu': 'ஆபரணங்கள் வருமான',
    'Store Transfer': 'ஸ்டோர் டிரான்ஸ்ஃபர்',
    'Transfer': 'டிரான்ஸ்ஃபர்',
    'List': 'பட்டியல்',
    'Pass': 'பாஸ்',
    'Member': 'உறுப்பினர்',
    'Member Heads':'உறுப்பினர் தலைப்பு',
    'Members': 'உறுப்பினர்கள்',
    'Membership': 'Membership',
    'Auditorium': 'அவைக்களம்',
    'Auditorium Report': 'ஆடிட்டோரியம் அறிக்கை',
    'Enquiry': 'விசாரணை',
    // 'Pooja': 'பூஜா',
    'edit product': 'தயாரிப்பு திருத்த',
    'add product': 'தயாரிப்பு சேர்க்க',
    'Date Of Birth': 'பிறந்த தேதி',
    'Pooja Enquiry': 'பூஜா விசாரணை',
    'Reports': 'அறிக்கைகள்',
    'Audit': 'தணிக்கை',
    'Pooja Report': 'பூஜா அறிக்கை',
    'Star Wise Pooja Report': 'ஸ்டார் வைஸ் பூஜா அறிக்கை',
    'Report': 'அறிக்கை',
    'Bank Statement Report': 'வங்கி அறிக்கை அறிக்கை',
    'Current Stock Report': 'தற்போதைய பங்கு அறிக்கை',
    'Membership Report': 'Membership Report',
    'Nadavaravu Report': 'அலங்கார வருமான அறிக்கை',
    'Stock Report': 'பங்கு அறிக்கை',
    'POS Report':'POS அறிக்கை',
    'Stock': 'பங்கு',
    'Income & Expense Report': 'வருமானம் மற்றும் செலவு அறிக்கை',
    'Expense Report': 'செலவு அறிக்கை',
    'Cheque Clearance Report':'காசோலை தெளிவான அறிக்கை',
    'Cheque Report':'காசோலை அறிக்கை',
    'Payment Payable': 'செலுத்த வேண்டிய பணம்',
    'Payment Receivable': 'கட்டணம் செலுத்துதல்',
    'Cancelled Transaction': 'ரத்து செய்யப்பட்ட பரிவர்த்தனை',
    'Income Collection': 'வருமான சேகரிப்பு',
    'Collection Report': 'சேகரிப்பு அறிக்கை ',
    'Collection': 'சேகரிப்பு' ,
    'Pooja Collection':'பூஜா சேகரிப்பு',
    'Pooja List':'பூஜா பட்டியல்',
    'Store Pass Report': 'பங்கு பிரச்சினை அறிக்கை',
    'Store Pass': 'பங்கு பிரச்சினை',
    'Transaction': 'பரிவர்த்தனை',
    'Purpose': 'நோக்கம்',
    'Type': 'வகை',
    'Period': 'காலம்',
    'Invoice': 'விலைப்பட்டியல்',
    'Bill': 'ர சி து',
    'Create Bill': 'பில் உருவாக்கவும்',
    'Create Invoice': 'விலைப்பட்டியல் உருவாக்கவும்',
    'Invoice Number': 'விலைப்பட்டியல் எண்',
    'Invoice At': 'விலைப்பட்டியல் தேதி',
    'Cleared At': 'மணிக்கு அழிக்கப்பட்டது',  
    'Cheque': 'காசோலை',
    'Cheque No': 'காசோலை எண்',
    'cash/cheque': 'பண / காசோலை ',
    'cash/cheque/pos':'பண / காசோலை / பாஸ்',
    'Devotee': 'பக்தர்',
    'Star': 'ஸ்டார்',
    'Unit': 'அலகு',
    'Material': 'பொருள்',
    'Pooja Date': 'பூஜா தேதி',
    'Quantity': 'அளவு',
    'quantity': 'அளவு',
    'Amount': 'தொகை',
    'Cost': 'செலவு',
    'Paid': 'பணம் செலுத்து',
    'Paid Amount': 'செலுத்திய தொகை',
    'Due': 'ಕಾರಣ',
    'Total': 'மொத்த',
    'Devotee name': 'பக்தர் பெயர்',
    'Devotee Name': 'பக்தர் பெயர்',
    'Collecting Person': 'நபர் சேகரித்தல்',
    'Opening': 'திறப்பு',
    'Incoming': 'வருகை',
    'Outgoing': 'வெளிச்செல்லும்',
    'Closing': 'மூடு',
    'is required': 'தேவை',
    'Date': 'தேதி',
    'diety': 'தெய்வம்',
    'Diety': 'தெய்வம்',
    'Prathishta': 'தெய்வம்',
    'Choose Star': 'நட்சத்திரத்தைத் தேர்வுசெய்க',
    'Choose Vazipadu': 'பூஜா தேர்வு செய்',
    'name': 'பெயர்',
    'Invalid': 'தவறான',
    'Address': 'முகவரி',
    'Email': 'மின்னஞ்சல்',
    'Advance': 'அட்வான்ஸ்',
    'Balance': 'இருப்பு',
    'Phone': 'தொலைபேசி',
    'phone': 'தொலைபேசி',
    'Submit': 'சமர்ப்பி',
    'submit': 'சமர்ப்பி',
    'Remove': 'அகற்று',
    'Both': 'இருவரும்',
    'Trancastion': 'பரிவர்த்தனை',
    'type': 'வகை',
    'CASH': 'பணம்',
    'CHEQUE': 'CHEQUE',
    'Status': 'நிலைமை',
    'Continuous Booking': 'தொடர்ச்சியான முன்பதிவு',
    'Booking': 'பதிவு',
    'days': 'தேதிகள்',
    'Available': 'கிடைக்கும்',
    'From Date': 'தேதி முதல்',
    'To Date': 'தேதி',
    'must be greater than From Date': 'தேதி முதல் விட வேண்டும்',
    'must be lesser than To Date': 'தேதிக்கு குறைவாக இருக்க வேண்டும்',
    'Selected days': 'தேர்ந்தெடுத்த தேதிகளின் எண்ணிக்கை',
    'All': 'எல்லா',
    'Month': 'மாதம்',
    'Thithi': 'திதி',
    'Week': 'வீக்',
    'Cancel': 'ரத்து',
    'cancel': 'ரத்து',
    'number': 'எண்',
    'Number': 'எண்',
    'No:': 'எண்:',
    'Billed Person Name': 'ரசிது நபர் பெயர்',
    'Book': 'பதிவு',
    'Billing Devotee': 'பில்லிங் பக்தர்',
    'Billing': 'பில்லிங்',
    'Issued Store': 'வழங்கப்பட்ட அங்காடி',
    'Choose Store': 'ஸ்டோரைத் தேர்வுசெய்க',
    'Store': 'கடைக்குத் ',
    'No Store': 'இல்லை கடை',
    'Personal Pooja': 'தனிப்பட்ட பூஜை',
    'SAMARPANAM': 'அலங்கார வருமான ',
    'Samarpanam': 'அலங்கார வருமான ',
    'NADAVARAVU': 'அலங்கார வருமான ',
    'Pooja Stall': 'பூஜா ஸ்டால்',
    'Pooja Booking': 'பூஜா முன்பதிவு',
    'STOCK REDUCING': 'குறைப்பு ஸ்டாக்',
    'Saleable': 'விற்பனை',
    'Rate': 'மதிப்பீடு',
    'Choose Item': 'பொருள் தேர்ந்தெடு',
    'Issued Item': 'வெளியிடப்பட்ட பொருள்',
    'Item': 'பொருள்',
    'Issued': 'வெளியிட்டது',
    'Entered quantity is out off current quantity': 'உள்ளீடு அளவு தற்போதைய அளவு வெளியே உள்ளது',
    'Recieved': 'பெறப்பட்டது',
    'Please choose any one of the above item': 'மேலே உள்ள உருப்படியிலுள்ள ஏதாவது ஒன்றைத் தேர்ந்தெடுக்கவும்',
    // 'Add': 'கூட்டு',
    'Thulabharam': 'துலாபாரம்',
    'You can\'t book this pooja for today': 'இந்த பூஜை இன்றே நீங்கள் பதிவு செய்ய முடியாது',
    'You can\'t book this pooja for tomorrow': 'நாளை இந்த பூஜை புத்தகத்தை நீங்கள் பதிவு செய்ய முடியாது',
    'Warning': 'எச்சரிக்கை',
    'Please change booking date': 'முன்பதிவு தேதி மாற்றவும்',
    'Limit exceeded': 'வரம்பு மீறப்பட்டது',
    'Anyway': 'எப்படியும்',
    'continue?': 'தொடர்ந்து?',
    'No stock available': 'பங்கு இல்லை',
    'Limit exceeded to book this pooja': 'இந்த பூஜை புத்தகத்திற்காக வரம்பை மீறியது',
    'Can add multiple devotees': 'பல பக்தர்கள் சேர்க்க முடியும்',
    'Print': 'அச்சிடு',
    'Salary': 'சம்பளம்',
    'Booking on': 'முன்பதிவு',
    'Timing': 'நேரம்',
    'Forenoon': 'காலை நேரம்',
    'Afternoon': 'மதியம்',
    'Full Day': 'முழு நாள்',
    'Temple': 'கோயில்',
    'Postage': 'போஸ்டேஜ்',
    'Confirm your postage address': 'உங்கள் அஞ்சல் முகவரியை உறுதிப்படுத்தவும்',
    'Same for all devotee': 'எல்லா பக்தர்களுக்கும் அதே',
    'Add devotee address': 'பக்தியின் முகவரியைச் சேர்க்கவும்',
    'Edit devotee address': 'பக்தர் முகவரி திருத்தவும்',
    'Logo': 'சின்னம்',
    'Counter': 'ಕೌಂಟರ್',
    'Receipt': 'ரசீது',
    'Rows': 'வரிசைகள்',
    'Keyboard': 'விசைப்பலகை',
    'License Expiry': 'உரிமம் காலாவதி',
    'Financial Year': 'நிதி ஆண்டு',
    'Basic': 'அடிப்படை',
    'Advanced': 'மேம்பட்ட',
    'Settings': 'அமைப்புகள்',
    'Printer': 'பிரிண்டர்', 
    'Action': 'அதிரடி',
    'Payment': 'கொடுப்பனவு',
    'Create Payment': 'பணம் கட்டுಿ',
    'Method': 'செய்முறை',
    'Template': 'டெம்ப்ளேட்',
    'Old': 'பழைய',
    'New': 'புதிய',
    'Change': 'மாற்றம்',
    'Change Password': 'கடவுச்சொல்லை மாற்று',
    'Is Metal': 'மெட்டல்',
    'Metal': 'மெட்டல்',
    'Default': 'இயல்புநிலை',
    'Booked On': 'முன்பதிவு',
    'Time': 'நேரம்',
    'Income': 'வருமான',
    'General Ledger': 'பொது பேரேடு',
    'Help': 'உதவி',
    'Welcome': 'வரவேற்பு',
    'STODA Editor': ' ஆசிரியர்',
    'Manual Backup': 'கையேடு காப்புப் பிரதி',
    'Documentation': 'ஆவணப்படுத்தல்',
    'Keyboard Shortcuts': 'விசைப்பலகை குறுக்குவழிகள்',
    'View License': 'உரிமத்தைக் காணுங்கள்',
    'Feature Request': 'சிறப்பு விண்ணப்பம்',
    'Report Issue': 'வெளியீடு அறிக்கை',
    'Privacy Statement': 'தனியுரிமை அறிக்கை',
    'Install Update': 'புதுப்பிக்கவும்',
    'Privileges': 'சிறப்புரிமை',
    'Packaged Pooja': 'தொகுப்பு பூஜா',
    'Add New ': 'புதியனவற்றை சேர்',
    'Add Packaged Pooja': 'தொகுப்பு பூஜை சேர்க்கவும்',
    'Edit Packaged Pooja': 'தொகு தொகுப்பு பூஜை',
    'Save': 'சேமி',
    'Update': 'புதுப்பிக்கப்பட்டது',
    'Number Of Devotees': 'பக்தர்களின் எண்ணிக்கை',
    'Exclude Today': 'இன்று தவிர்க்கவும்',
    'Number Of Days': 'நாட்கள் எண்ணிக்கை',
    'Choose Thithi': 'திதி தெரிவு',
    'Invoice Total': 'விலைப்பட்டியல் மொத்த',
    'Invoice Received [Cash]': 'விலைப்பட்டியல் பெறுதல் [ரொக்க]',
    'Invoice Received [Bank]': 'விலைப்பட்டியல் பெறப்பட்டது [வங்கி]',
    'Receivable Invoice': 'பெறத்தக்க விலைப்பட்டியல்',
    'Old Invoice Received [Cash]': 'பழைய விலைப்பட்டியல் மீட்டெடுப்பு [பண]',
    'Old Invoice Received [Bank]': 'பழைய விலைப்பட்டியல் பெறப்பட்டது [வங்கி]',
    'Old Receivable Invoice': 'Old Receivable Invoice',
    'Total Receivable': 'Total Receivable',
    'Direct Withdrawal':'Direct Withdrawal',
    'Bill Total': 'பில் மொத்தம்',
    'Bill Paid [Cash]': 'பில் செலுத்துதல் [பண]',
    'Bill Paid [Bank]': 'பில் கட்டணம் [வங்கி]',
    'Payable Bills': 'செலுத்த வேண்டிய பில்கள்',
    'Old Bill Total': 'பழைய பில் மொத்தம்',
    'Old Bill Paid [Cash]': 'பழைய பில் பே [பண]',
    'Old Bill Paid [Bank]': 'பழைய பில் பே [வங்கி]',
    'Old Payable Bills': 'Old Payable Bills',
    'Total Payable Bills': 'Total Payable Bills',
    'Direct Deposit': 'Direct Deposit',
    'Old Balance': 'Old Balance',
    'Recievable': 'பெறத்தக்க',
    'Total Paid': 'மொத்தம் செலுத்தியது',
    'Donation': 'நன்கொடை',
    'Marriage': 'திருமண',
    'Marriage Certificate':'திருமண சான்றிதழ்',
    'Certificate' : 'சான்றிதழ்',
    'POS': 'பிஓஎஸ்',
    'Complete Total': 'முழு மொத்தம்',
    'Cash': 'பணம்',
    'Cash Book': 'பண புத்தக',
    'Day Book': 'நாள் புத்தகம்',
    'Consolidated': 'தொகுக்கப்பட்டு',
    'Agreed':'ஒப்பு',
    'Mother Name': 'தாய் பெயர்',
    'Father Name': 'தந்தையின் பெயர்',
    'Marriage Date': 'திருமண தேதி',
    'Age': 'கையொப்பம்',
    'Sign':'குறி',
    'Secretary':'காரியதரிசி',
    'Place':'இடம்',
    'Marriage Place':'திருமண இடம்',
    'The marriage of married couple shows that was done according to Hindu custom.':'இந்து தெய்வங்களின்படி திருமணமான தம்பதிகள் திருமணம் செய்து கொண்டது.',
    'Bride':'மணப்பெண்',
    'Groom':'மாப்பிள்ளை',
    'Voucher No':'வவுச்சர் எண்',
    'Excess Amount':'அதிக தொகை',
    'Sale':'விற்பனை',
    'Sale Report':'விற்பனை அறிக்கை',
    'Sale Head':'விற்பனை தலைப்பு'
};
